import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import GuiaComprasPage from "../pages/guia-compras/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <ArticlePage />,
  },
  {
    path: "/guia-de-compras",
    element: <GuiaComprasPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;